import React, { useEffect, useState } from "react";
import { base_url } from "../../utils/AxiosConfig";
import axios from "axios";
import { format, parseISO } from "date-fns";


const ViewPayroll = ({ popUpData, loadPayroll, setLoadPayroll, setpopUpData }) => {


  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
        let companyCode = null

        if (storedUserDataArray) {
          companyCode = storedUserDataArray[0].cmpcode
        }

  const [infoData,setInfoData] = useState([])


  const getInfo  = async(empId) => {

    console.log('callGetInfo')


    setInfoData([])
    try {
      const response = await axios.get(`${base_url}api/PersonalInfoAdditionList/${companyCode}/${empId}`)

      // console.log(response.data)

      if(response.status === 200) {
        setInfoData(response.data)
      }
    } catch (error) {
      console.log('errorFetchingInfo')
    }
  }

  // Helper function to format date
const formatDate = (dateString) => {
  const parsedDate = parseISO(dateString); // Parse the ISO string to a Date object
  return format(parsedDate, 'yyyy-MM-dd'); // Format the parsed Date object
};

  useEffect(() => {
      if(popUpData){
        getInfo(popUpData?.EmpId)
      }
  },[popUpData])

  // useEffect(() => {
  //   if(loadPayroll) {
  //     getInfo(popUpData?.EmpId)
  //   }
  // },[loadPayroll])

  // console.log('infoData',infoData)

  return (
    <div>
      <div>
        <div
          class="modal fade"
          id="staticBackdropnew"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h1
                  class="modal-title  text-secondary fs-small"
                  id="staticBackdropLabel"
                >
                  View Payroll
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setLoadPayroll(false)
                    setpopUpData('')
                  }}
                ></button>
              </div>
              <div class="modal-body">
                <div className="container-fluid">
                  <table class="table border">
                    <tbody>
                      <tr>
                        <td>EmpID</td>
                        <td>{popUpData?.EmpId}</td>
                      </tr>
                      <tr>
                        <td>Name</td>
                        <td>{popUpData?.Name}</td>
                      </tr>
                      <tr>
                        <td>Designation</td>
                        <td>{popUpData?.JobTitle}</td>
                      </tr>

                      <tr>
                        <td>Loans And Advance</td>
                        <td>0</td>
                      </tr>

                      <tr>
                        <td>Salary Outstanding</td>
                        <td>0</td>
                      </tr>
                    </tbody>
                  </table>
                 <div class="scroll h-auto" style={{ maxHeight: '400px', overflow: 'auto' }}>
                    <table class="table">
                      <tbody>
                        <tr className="">
                          <td>SI Now</td>
                          <td>Category</td>
                          <td>Amount</td>
                          <td>Payroll</td>
                          <td>Remarks</td>
                        </tr>
  
                        {
                          infoData && infoData.length > 0 && infoData.map((item,index) => (
                            <tr className="dataTr" key={index}>
                              <td>{index+1}</td>
                              <td>{item.Category}</td>
                              <td>{item.Amount}</td>
                              <td>{formatDate(item.ADate)}</td>
                              <td>{item.Notes}</td>
                          </tr>
                          ))
                        }
  
                        {
                          infoData && infoData.length === 0 &&
  
                          <tr>
                            <td colSpan={5} style={{color:'red'}}>
                              No Data Available
                            </td>
                          </tr>
                        }
                      
                      </tbody>
                    </table>
                 </div>
                </div>
              </div>
              {/* <div class="modal-footer">
     
      <button type="button" class="btn dash-btn">Save</button>
    </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPayroll;
